import { SsnCardVerificationMock } from "../components/ssnCardVerificationMock/SsnCardVerificationMock";

export function SsnCardVerificationMockPage() {
  return <SsnCardVerificationMock />;
}
